import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { DataConnectorMapping } from 'src/app/domainObjects/dataConnectorMapping';
import { DataTransformerConfig } from 'src/app/domainObjects/dataTransformConfig';
import { ColumnCalcTransformRule, IfErrorType } from 'src/app/domainObjects/transformers/columnCalcTransform';
import { ConfigService } from 'src/app/services/config/config.service';
import { ConfigViewModelService } from 'src/app/services/configViewModel/config-view-model.service';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { NavigationService } from 'src/app/services/navigation/navigation.service';
import { DataFarmViewModel } from 'src/app/viewModels/dataFarmViewModel';
import { DataTransformConfigViewModel } from 'src/app/viewModels/dataTransformConfigViewModel';
import { ImportDataViewModel } from 'src/app/viewModels/importDataViewModel';
import { PreviewTableComponent, ColumnInfo } from '../../../preview-table/preview-table.component';
import { ColumnCalcRuleViewModel } from './columnCalcRuleViewModel';
import { ColumnCalcViewModel, DataType } from './columnCalcViewModel';
import { TransformPipelineService } from '../../../../services/transformPipeline/transform-pipeline.service';
import { BaseTransformerUIComponent } from '../../../dataTransformConfig/transformers/base/base-transformer-ui/base-transformer-ui.component';
import { DataDictionaryService } from 'src/app/services/dataDictionary/data-dictionary.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { FormBuilder, FormGroup, UntypedFormControl } from '@angular/forms';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { TransformRuleViewModel } from 'src/app/viewModels/transformRuleViewModel';
import { UserDataService } from 'src/app/services/user-data-service';
import { RefineryPresenceService } from 'src/app/services/refinery-presence.service';
import { TransformType, TransformTypeUtil } from 'src/app/domainObjects/transformType';
import { SaveCurrntTransfrmcacheRequest } from 'src/app/messaging/saveCurrntTransfrmcacheRequest';
import { InputPrvwFilterViewModel } from 'src/app/viewModels/inputPrvwFilterViewModel';
import { TransformerTopHeaderComponent } from '../../transformer-top-header/transformer-top-header.component';
import { DataFarmTypeUtil } from 'src/app/domainObjects/dataFarmType';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ExpressionEditorComponent, FieldSelectionItem } from 'src/app/views/shared/expression-editor/expression-editor.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-column-calc-transform-detail',
    templateUrl: './column-calc-transform-detail.component.html',
    styleUrls: ['./column-calc-transform-detail.component.css'],
    standalone: false
})
export class ColumnCalcTransformDetailComponent extends BaseTransformerUIComponent<ColumnCalcViewModel> implements OnInit {

  /** Column Calc has no source-field concept at all (rules are expressions, not per-field
   * rules) — Smart Sample dropdown is simply every Input Farm field except "row" — the
   * Architect, 2026-09-26. */
  get columnCalcAvailableSourceFields(): string[] {
    return (this.viewModel?.sourceColumns ?? [])
      .map(c => c.text)
      .filter(f => f && f !== 'row');
  }

  selectedIndex: number = 0;
  isResultsPanelExpanded = false;
  isPreviewPanelExpanded = false;   
  transformerInputPreviewCacheKey = ""; 
  dataSource: MatTableDataSource<ColumnCalcRuleViewModel>;
  previewDataViewModel: ImportDataViewModel;
  isRuleSetEmpty = true;
  isRuleExecuting = false;
  displayedColumns: string[] = [
    'actions',
    'index',
    'name',
    'targetDataType',
    'targetField',
    'expression',
    'ifError',
    'isEnabled',
    'result',
    'details'];

  updateDataSource: any;
  isRulesMaximized = false;
  inputPrvwFilterViewModel = new InputPrvwFilterViewModel();
  sortCtrl = new UntypedFormControl('');
  form: FormGroup;
  formparam: FormGroup;
  optionitemDD: FieldSelectionItem[] = [];
  optionitemInputColumns: FieldSelectionItem[] = [];
  operators = ['+', '-', '*', '/', '^', '(', ')', ','];

  constructor(
    activeRoute: ActivatedRoute,
    errorService: ErrorReportingService,
    matDialog: MatDialog,
    snackBar: MatSnackBar,
    router: Router,
    configViewModelService: ConfigViewModelService,
    configService: ConfigService,
    navService: NavigationService,
    transformPipelineService: TransformPipelineService,
    userData: UserDataService,
    dataDictService: DataDictionaryService,
    refineryPresence: RefineryPresenceService,
    private cdRef: ChangeDetectorRef,private fb: FormBuilder,private sanitizer: DomSanitizer) {

    super(activeRoute, errorService, matDialog, snackBar, router, configViewModelService, configService, navService, transformPipelineService, userData,dataDictService, refineryPresence);
    this.transformType = TransformType.columnCalc;
  }
  @ViewChild(TransformerTopHeaderComponent) topHeaderComponent: TransformerTopHeaderComponent;
  transformType:TransformType;
  options: string[] =[];
  defaultSourceColumn='Source Field';
  ngOnInit(): void {
    super.ngOnInit();
    //no solid validation in parameter component
    this.isParameterFormValid=true;
    this.userData.setResultsTabClicked(false);
    this.userData.setOutputTabClicked(false);
    this.resetInputPrvwViewModel();
    this.transformerInputPreviewCacheKey = "";
    // this.registerFormGroup(this.form);
    // this.registerFormGroup(this.formparam);
    //this.totalRulesColumnDisplay();
  }

  protected override async onRouteActivated(_routeParams: any): Promise<void> {
    this.viewModel = new ColumnCalcViewModel(
      this.dataDictService,
      this.configService,
      this.dataTransformConfigViewModel,
      this.transformViewModel);
    this.viewModel.farmType=this.userData.getSelectedNodeDetails().farmtypeid;
    this.configureTargetColumnsFarmtypeid(this.userData.getSelectedNodeDetails().farmtypeid);
    this.snapshotPreState();

    this.dataSource = new MatTableDataSource<ColumnCalcRuleViewModel>(this.viewModel.rules);
    this.isRuleSetEmpty = this.viewModel.rules.length === 0;

    if (this.previewTable) { this.previewTable.clear(); }
    if (this.outputDataFarmPreviewTable) { this.outputDataFarmPreviewTable.clear(); }

    await this.setTransformerDetails(this.transformType);
    await this.downloadInputDataAsync();
    this.viewModel.parameters.sourceColumns = this.viewModel.sourceColumns;
    await this.loadInputAndDDColumns();
    this.viewModel.rules.forEach(async rule=>{
      rule.targetFarmColumns = await this.getDDFilterByDataType(this.optionitemDD,rule.targetDataType);
    });
  }

  onTransformTextChanged(){
    this.viewModel.transformViewModel.name=this.viewModel.transform.name;
    var currenttransform=this.dataTransformConfigViewModel.transforms.find(x=>x.guid==this.viewModel.transform.guid);
    currenttransform.name=this.viewModel.transform.name;
    currenttransform.transform.name=this.viewModel.transform.name;
    var vartransform=this.transformslists.find(x=>x.guid==this.viewModel.transform.guid);
    vartransform.name=this.viewModel.transform.name;
  }
  dropTable(event: CdkDragDrop<MatTableDataSource<TransformRuleViewModel>>): void {
    const prevIndex = event.previousIndex;
    const currentItem: ColumnCalcRuleViewModel = event.item.data;
    currentItem.index = prevIndex;
    moveItemInArray(this.viewModel.rules, prevIndex, event.currentIndex);
    this.viewModel.reindexRules();
    this.dataSource.data = this.viewModel.rules;
  }

  onRunChanged(event: MatSlideToggleChange): void {
    this.viewModel.rules.forEach( r => r.run = event.checked);
  }

  toggleRulesHeight(): void {
    this.isRulesMaximized = !this.isRulesMaximized;
  }
  
  onDeleteRule(rule: ColumnCalcRuleViewModel): void {
    this.showConfirmDialog('Delete Confirmation', `Are you sure you want to delete this rule?`, (confirmed) => {
      if (confirmed) {
        const index = this.viewModel.rules.indexOf(rule);
        this.viewModel.rules.splice(index, 1);
        this.viewModel.reindexRules();
        
        this.dataSource.data = this.viewModel.rules;
        this.isRuleSetEmpty = this.viewModel.rules.length === 0;
        //update rule table height
        if(this.viewModel.rules.length<=10){
          this.minrowcount=this.viewModel.rules.length;
        }else{
          this.minrowcount=10;
        }
        this.maxrowcount=this.viewModel.rules.length;
      }
    });
  }

  async onDuplicateRule(sourceRule: ColumnCalcRuleViewModel): Promise<void> {
    const vm = new ColumnCalcRuleViewModel(sourceRule.toRule());
    //populate target farm columns based on default data type
    vm.targetFarmColumns = await this.getDDFilterByDataType(this.optionitemDD,vm.targetDataType);

    this.viewModel.rules.splice(sourceRule.index, 0, vm);
    this.viewModel.reindexRules();
    this.dataSource.data = this.viewModel.rules;
    //update rule table height
    if(this.viewModel.rules.length<=10){
      this.minrowcount=this.viewModel.rules.length;
    }else{
      this.minrowcount=10;
    }
    this.maxrowcount=this.viewModel.rules.length;
    if(vm.index==this.maxrowcount){this.isScrollBottom=true; }else{this.isScrollBottom=false;}
  }
  minrowcount:number=10;
  maxrowcount:number=100;
  isScrollBottom:boolean=true;
  async addNewRule(): Promise<void> {
    const id = this.viewModel.rules.length;
    const rule = new ColumnCalcTransformRule();
    rule.ruleId = id;
    rule.index = id;
    rule.run=true;
    const vm = new ColumnCalcRuleViewModel(rule);
    vm.targetDataType = DataType.string;
    vm.ifError= IfErrorType.fail;
    vm.expression="";
    //populate target farm columns based on default data type
    vm.targetFarmColumns = await this.getDDFilterByDataType(this.optionitemDD,vm.targetDataType);

    this.viewModel.rules.push(vm);
    this.isRuleSetEmpty = this.viewModel.rules.length === 0;
    this.dataSource.data = this.viewModel.rules;
    
    if(this.viewModel.rules.length<=10){
      this.minrowcount=this.viewModel.rules.length;
    }else{
      this.minrowcount=10;
    }
    this.maxrowcount=this.viewModel.rules.length;
  }

  getClassForRow(sender: PreviewTableComponent, row: any, colInfo: ColumnInfo, colInfos: ColumnInfo[]): string {
    try {
      return this.getClassForRowBase(sender, row, colInfo, colInfos);
    } catch (err) {
      return null;
    }
  }

  async saveConfig(): Promise<void> {
    if (!await this.validateRules()) {
      this.displayError("Validation failed. Please correct the highlighted fields in:\n" + this.invalidRules.join("\n"),"Validation Error");
      return;
    }
    if (this.dataTransformConfigViewModel.dataTransformerConfig?.id || this.dataTransformConfigViewModel.dataTransformerConfig?.guid) {
      this.saveConfigImpl(this.dataTransformConfigViewModel.dataTransformerConfig.name);
    } else {
      this.showSaveConfigDialog(async (configName: string) => {
        this.saveConfigImpl(configName);
      });
    }
  }

  async saveConfigImpl(configName: string): Promise<void> {
    var currenttransformer_sampleStart = this.viewModel.parameters.sampleStart ;
    var currenttransformer_sampleEnd = this.viewModel.parameters.sampleEnd  ;
    if (currenttransformer_sampleStart >=  currenttransformer_sampleEnd) {
      this.displayWarning(
        'Sample Start was greater than to Sample End, so it was auto-reset to 1.',
        'Warning',
        undefined,
        () => {
          this.viewModel.parameters.sampleStart = 1;
        }
      );
      return;
    }
    if(currenttransformer_sampleStart > this.totalInputRows || currenttransformer_sampleEnd > this.totalInputRows )
    {
      this.displayWarning(
        'Sample Range exceeded the Input Farm size and was auto-corrected to the maximum limit.',
        'Warning',
        undefined,  // no exception to pass
        () => {
        
          if (currenttransformer_sampleStart > this.totalInputRows) {
          this.viewModel.parameters.sampleStart = 1;
          }
          if (currenttransformer_sampleEnd > this.totalInputRows) {
            this.viewModel.parameters.sampleEnd = this.totalInputRows;
          }
        }
      );
      return;
    }
    const busyIndicator = this.showBusyDialog('Please wait...');
    try {
      let config = this.dataTransformConfigViewModel.dataTransformerConfig ?? new DataTransformerConfig();

      config.name = configName;
      config.organizationId = 1;
      config.dataSourceType = this.dataTransformConfigViewModel.dataSourceType;
      config.selectedIngestFarmGuid = this.dataTransformConfigViewModel.selectedIngestFarmGuid;
      
      // Save the Data Connectors
      config.dataConnectorMappings = this.dataTransformConfigViewModel.ingestConfigs
      .map ( ingestConfig =>
        new DataConnectorMapping(
          ingestConfig.id,
          ingestConfig.name,
          ingestConfig.targetDataFarm,
          ingestConfig.dataConnector.toDataConnector(),
          ingestConfig.columnMap
            .map(i => i.toColumnMapDefinition()),
            ingestConfig.guid,
          ingestConfig.masterColumnMapGuid)
      );

      // Save Transforms
      config.transforms = this.dataTransformConfigViewModel.transforms.map(t => t.transform);

      // Save the transform
      //const transform = config.transforms.find(t => t.id === this.viewModel.transform?.id) ?? this.viewModel.transformViewModel.transform;
      const transform = this.viewModel.transformViewModel.transform;
      
      transform.transformConfig = this.viewModel.toTransformConfig();
      // transform.dataFarmName = this.viewModel.dataFarm.name;
      // transform.dataFarmType = this.viewModel.dataFarm.dataFarmType;

      // TODO: Maintain list of transforms for this config
      const existingTransform = config.transforms.find(t => t.guid === transform.guid);
      if (existingTransform) {
        config.transforms.splice(config.transforms.indexOf(existingTransform), 1);
      }
      config.transforms.push(transform);
      

      // Save the ingest transforms
      //console.log(JSON.stringify(config));

      config = await this.configService.upsertConfig(config);
      this.userData.setSelectedConfigJson(config);
      this.configViewModelService.setDataTransformConfigViewModel(new DataTransformConfigViewModel(config));
      this.userData.setSelectedTransform(this.dataTransformConfigViewModel.transforms.find(x=>x.guid=== this.userData.getSelectedTransform().guid));
      //update preViewModel
      this.snapshotPreState();

      // SAve the current node status to Not RunConfigRequest.
      const selectedNode = this.userData.getSelectedNodeDetails();
      
      //Invoke the save current transformer cache api
       const activeTransformGuid = this.userData.getSelectedTransform().guid
       const userId = this.userData.getUserId()
       const orgId = this.userData.getOrgId()
       var saveCurrentTransformerCacheRequest: SaveCurrntTransfrmcacheRequest = new SaveCurrntTransfrmcacheRequest(userId, orgId, selectedNode.id, selectedNode.refineryConfigGuid, this.dataTransformConfigViewModel.selectedIngestFarmGuid, activeTransformGuid);
       await this.configService.saveCurrentTransformerCache(saveCurrentTransformerCacheRequest);
       await this.configService.getRefineryConfigByGuidAsync(this.userData.getRefineryId());
       this.getCacheStatus();
       // this.cdRef.detectChanges();
      this.snackBar.open(`Successfully saved transform pipeline '${this.userData.getSelectedTransform().name}'`, 'Dismiss', {
        duration: 5000
      });
      busyIndicator.close();

    } catch (err) {
      busyIndicator.close();
      this.displayError(`Failed to save '${this.userData.getSelectedTransform().name}'`, 'Error', err);
    }
  }

  onParameterFormStatusChange(status: boolean) {
    this.isParameterFormValid = status;
  }
  onTabClick(event: MatTabChangeEvent): void {
    const selectedTabIndex = event.index;
    const selectedTabLabel = event.tab.textLabel;
    this.selectedIndex = selectedTabIndex;
 
    // Alert the tab index and label
   // alert(`Tab clicked: ${selectedTabLabel} (Index: ${selectedTabIndex})`);
   this.userData.setResultsTabClicked(false);
   if(selectedTabLabel.match("Output") && selectedTabIndex == 1) {
    this.userData.setOutputTabClicked(true)
    this.setOutputPreviewTabSlctnStatus();
   } else {
      this.userData.setOutputTabClicked(false);
      this.setInputPreviewFilterViewModel();
   }
  }
  setActivityNamerResultsTabClicked() {
    if(this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey.length > 0) {
      this.transformerInputPreviewCacheKey = this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey;
    }
    
    this.userData.setOutputTabClicked(false);
    this.userData.setResultsTabClicked(true);
    this.resetTransformerInputPrvwModelData();
    this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel);
    this.isResultsPanelExpanded = true;
    this.isPreviewPanelExpanded = false;
  }

  setActivityNamerPreviewTabClicked() {
    if(this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey.length > 0) {
      this.transformerInputPreviewCacheKey = this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey;
    }
    this.userData.setResultsTabClicked(false);
    this.userData.setOutputTabClicked(false);
    this.isResultsPanelExpanded = false;
    this.isPreviewPanelExpanded = true;
    if(this.selectedIndex == 0) {
      this.setInputPreviewFilterViewModel();
    }
    if(this.selectedIndex == 1) {
      this.setOutputPreviewTabSlctnStatus();
    }
  }

  setOutputPreviewTabSlctnStatus(): void {
    this.userData.setResultsTabClicked(false);
    this.userData.setOutputTabClicked(true);
    this.resetTransformerInputPrvwModelData();
    this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel);
  }

  setInputPreviewFilterViewModel() {
    this.inputPrvwFilterViewModel.previewType = "TransformerInput";
    this.setTransformerInputPrvwCacheKey();
    this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel)
  }
  
  setTransformerInputPrvwCacheKey() {
    if(this.transformerInputPreviewCacheKey.length > 0 && this.inputPrvwFilterViewModel.farmId.length > 0) {
      this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey = this.transformerInputPreviewCacheKey;
      this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel);
    }
  }

  resetInputPrvwViewModel() {
    this.inputPrvwFilterViewModel.farmId = "";
    this.inputPrvwFilterViewModel.collookupFarmId = "";
    this.inputPrvwFilterViewModel.nodeType = "";
    this.inputPrvwFilterViewModel.previewType = "TransformerInput";
    this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey = "";
  }

  resetTransformerInputPrvwModelData() {
    this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey = "";
    this.inputPrvwFilterViewModel.previewType = "";
  }
  
  get isValidateParameters(): boolean {
    return false;//!(this.isParameterFormValid && this.formparam.valid);
  }
  get isValidateAdvanceSettings(): boolean {
    return this.form.invalid;
  }
  /** Reset Transformer support (the Architect, 2026-09-27) -- Column Calc has no
   *  type-specific advanced settings of its own beyond the common
   *  TransformerParametersComponent fields (sortInfo/includeInResults/sampleStart/
   *  sampleEnd/runAll), which parametersComponent.setDefaultAndRemoveInvalidValues()
   *  already owns generically. Mirrors every other transform type's own
   *  "if(parameters){...}" master-config lookup so this stays correct if Column Calc
   *  ever gains its own advanced settings later, rather than asserting defaults that
   *  don't exist today. */
  async setDefaultValues(transformType:TransformType): Promise<void>{
    const selectedNode=this.userData.getSelectedNodeDetails();
    const masterconfig=this.userData.getMasterTransformers().find(x=>x.id==transformType);
    var parameters=masterconfig.parameters.find(x=>x.farmtypeid==selectedNode.farmtypeid);
    if(parameters){
      // No type-specific advanced settings to default -- see method comment above.
    }
  }
  async removeInvalidValues(): Promise<void>{
    // No type-specific advanced settings to validate -- see setDefaultValues above.
  }
  async loadImportTransformer(transform: any): Promise<void>{
    const busyIndicator = this.showBusyDialog('Please wait...');
    try{
      if(this.userData.getSelectedNodeDetails().farmtypeid!=transform.farmType){
        this.displayError("Current DataFarmType is " + DataFarmTypeUtil.toString(this.userData.getSelectedNodeDetails().farmtypeid) + ". But you are trying to load a different DataFarmType: " + DataFarmTypeUtil.toString(transform.farmType),"Error");
        return;
      }else if(this.transformType!=transform.transformType){
        this.displayError("Current transform is " + TransformTypeUtil.toString(this.transformType) + ". But you are trying to load a different transform type: " + TransformTypeUtil.toString(transform.transformType),"Error");
        return;
      }
      var ctranformconfig=this.dataTransformConfigViewModel.transforms.find(x=>x.guid=== this.userData.getSelectedTransform().guid);
      ctranformconfig.transform.transformConfig=transform;
      var newmodel =new ColumnCalcViewModel(this.dataDictService,this.configService,this.dataTransformConfigViewModel,ctranformconfig);
      // force new object reference for UI refresh
      this.viewModel.rules=[];
      this.viewModel.rules=[...newmodel.rules];
      this.isRuleSetEmpty = this.viewModel.rules.length === 0;
      this.dataSource.data = this.viewModel.rules;
      //update Parameters
      // this.viewModel.parameters.sourceColumn=newmodel.parameters.sourceColumn;
      // this.viewModel.parameters.targetColumn=newmodel.parameters.targetColumn;
      // this.viewModel.parameters.userColumn=newmodel.parameters.userColumn;
      // this.viewModel.parameters.timeColumn=newmodel.parameters.timeColumn;
      this.viewModel.parameters.sortInfo=newmodel.parameters.sortInfo;
      this.viewModel.parameters.includeInResults=newmodel.parameters.includeInResults;
      this.viewModel.parameters.sampleStart =newmodel.parameters.sampleStart;
      this.viewModel.parameters.sampleEnd =newmodel.parameters.sampleEnd;
      this.viewModel.parameters.runAll =newmodel.parameters.runAll;
      // this.viewModel.parameters.deleteMisses =newmodel.parameters.deleteMisses;
      // this.viewModel.parameters.missName =newmodel.parameters.missName;
      //other parameters

      //populate rule table targetfield
      this.viewModel.rules.forEach(async rule=>{
        rule.targetFarmColumns = await this.getDDFilterByDataType(this.optionitemDD,rule.targetDataType);
      });
      //update rule table height
      if(this.viewModel.rules.length<=10){
        this.minrowcount=this.viewModel.rules.length;
      }else{
        this.minrowcount=10;
      }
      this.maxrowcount=this.viewModel.rules.length;
    }catch (err) {
      this.displayError(`Failed to save import transformer`, 'Error', err);
    }finally {
      busyIndicator.close();
    }
  }
  
  onSetDefaultRule(defaultfield:string){
    
  }
  totalRulesColumnDisplay(){
    
  }
  onToggleRulesColumnDisplay(){
    this.totalRulesColumnDisplay();
  }
  async onTargetDataTypeChange(rule: ColumnCalcRuleViewModel) {
    rule.targetField=undefined;
    rule.targetFarmColumns = [];
    rule.targetFarmColumns = await this.getDDFilterByDataType(this.optionitemDD,rule.targetDataType);
  }

  async getDDFilterByDataType(optionitemDD: FieldSelectionItem[],dataType: DataType): Promise<string[]> {
    let targetFarmColumns= [];
    if(dataType==DataType.string){
      optionitemDD.filter(col=>(this.getDataType(col.dataType)=="string")).forEach(map=>{
        targetFarmColumns.push(map.name);
      });
    }else if(dataType==DataType.integer){
      optionitemDD.filter(col=>(this.getDataType(col.dataType)=="int")).forEach(map=>{
        targetFarmColumns.push(map.name);
      });
    }else if(dataType==DataType.float){
      optionitemDD.filter(col=>(this.getDataType(col.dataType)=="float")).forEach(map=>{
        targetFarmColumns.push(map.name);
      });
    }else if(dataType==DataType.timestamp){
      optionitemDD.filter(col=>(this.getDataType(col.dataType)=="datetime")).forEach(map=>{
        targetFarmColumns.push(map.name);
      });
    }else if(dataType==DataType.duration){
      optionitemDD.filter(col=>(this.getDataType(col.dataType)=="timedelta")).forEach(map=>{
        targetFarmColumns.push(map.name);
      });
    }else {
      optionitemDD.forEach(map=>{
        targetFarmColumns.push(map.name);
      });
    }
    return targetFarmColumns;
  }

  async onRuleExpressionCellClicked(rule: ColumnCalcRuleViewModel): Promise<void> {
    let title: string='Expression Editor';
    let ruleNo: number=rule.index;
    let ruleName: string=rule.name;
    let targetField: string=rule.targetField;
    let fields: FieldSelectionItem[] = [];
    let dialogWidth: string='500px'
    /* ---------- Input Data Farm ---------- */
    fields.push(...this.optionitemInputColumns);
    /* ---------- Dictionary Fields remove input farm---------- */
    const inputNames = new Set(this.optionitemInputColumns.map(c => c.name));
    fields.push(...this.optionitemDD.filter(dd => !inputNames.has(dd.name)));
    /* Remove = then generate html*/
    let expressionhtml=this.getExpressionHtml(rule.expression)

    this.showExpressionEditorDialogOption(title, ruleNo,ruleName,targetField,fields,dialogWidth, expressionhtml,
      async (items: string,eventname:string) => {
        if(eventname=='save'){
          rule.expression = items;
        }
    });
  }
  showExpressionEditorDialogOption(
    title: string,
    ruleNo: number,
    ruleName: string,
    targetField: string,
    fields: FieldSelectionItem[],
    dialogWidth: string,
    existingItems: string,
    onClosed: (items: string,eventname:string) => any): void {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {items: existingItems, title, ruleNo,ruleName,targetField,fields,onClosed};
    dialogConfig.width = dialogWidth;
  
    const dialogRef = this.matDialog.open(ExpressionEditorComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      onClosed(result.items,result.eventname);       
    });
  }

  getExpressionHtml(html: string): string {
    if (!html) return '';
    const items = html.trim().split(/\s+/);
    let innerhtml = '';
    items.forEach(item => {
      const span = document.createElement('span');
      span.textContent = item;

      if (this.optionitemInputColumns?.find(col => col.name === item)) {
        span.style.color = '#98FB00';
      }
      else if (this.optionitemDD?.find(col => col.name === item)) {
        span.style.color = '#ED7D31';
      }
      else if (this.operators?.includes(item)) {
        span.style.color = '#5B9BD5';
      }
      else {
        span.style.color = '#808080';
      }
      innerhtml += span.outerHTML + ' ';
    });
    return innerhtml.trim();
  }
  getExpressionSafeHtml(html: string): SafeHtml {
    if (!html) {
      return '';
    }
    const items=html.split(' ');
    var innerhtml="";
    items.forEach(item=>{
      const span = document.createElement('span');
      span.textContent = ` ${item} `;
      if(this.optionitemInputColumns.find(col=>col.name==item)){
        span.style.color = '#98FB00';
      }else if(this.optionitemDD.find(col=>col.name==item)){
        span.style.color = '#ED7D31';
      }else if(this.operators.find(col=>col==item)){
        span.style.color = '#5B9BD5';
      }else{
        span.style.color = '#808080'; // Default color for unknown items
      }
      innerhtml += span.outerHTML;
    })
    return this.sanitizer.bypassSecurityTrustHtml(innerhtml);
  }

  async loadInputAndDDColumns(): Promise<void>{
    /* ---------- Input data farm Fields ---------- */
    // Copy before sorting (the Architect, 2026-09-27): displayedColumnInfos is the
    // SAME array the Input Data Farm preview table renders from. Array.sort() mutates
    // in place, so sorting it directly here was silently reordering the actual preview
    // table's columns to alphabetical -- this dropdown only needs an alphabetized VIEW,
    // never a reordering of the source the preview table is bound to.
    const inputColumns = this.inputDataFarmPreviewTable?.displayedColumnInfos ?? [];
    this.optionitemInputColumns = [...inputColumns]
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(map => new FieldSelectionItem(map.name, map.pydataType, "#98FB00"));
    /* ---------- Dictionary Fields ---------- */
    const optionitem=await this.getDataDictOptionItemDataTypePD(this.userData.getSelectedNodeDetails().farmtypeid) ?? [];
    this.optionitemDD = [...optionitem]
      .sort((a, b) => a.value.localeCompare(b.value))
      .map(item => new FieldSelectionItem(item.value, item.dataType, "#ED7D31"));
  }
  isValidRule:boolean=true;
  /** The rules the last check found incomplete ("Rule 2: Name"), for the message. */
  invalidRules: string[] = [];
  async validateRules(): Promise<boolean> {
    this.isValidRule = true;
    this.invalidRules = [];
    for (const rule of this.viewModel.rules) {
      if (!TransformRuleViewModel.enabledRules([rule]).length) {
        // A rule that is off is not run, so it is not checked (and shows no highlight).
        rule.tooltipMessageTargetField = ''; rule.tooltipTypeTargetField = '';
        rule.tooltipMessageExpression = ''; rule.tooltipTypeExpression = '';
        continue;
      }
      const targetField = (rule.targetField ?? '').trim();
      const expression = (rule.expression ?? '').trim();

      if (!targetField) {
        rule.tooltipMessageTargetField = "Target field is required.";
        rule.tooltipTypeTargetField = "red";
        this.isValidRule = false;
      }else{
        rule.tooltipMessageTargetField = '';
        rule.tooltipTypeTargetField = '';
      }
      
      if (!expression) {
        rule.tooltipMessageExpression = "Expression is required.";
        rule.tooltipTypeExpression = "red";
        this.isValidRule = false;
      }else{
        rule.tooltipMessageExpression = '';
        rule.tooltipTypeExpression = '';
      }
      if (!targetField || !expression) {
        this.invalidRules.push(TransformRuleViewModel.label(rule));
      }
    }
    return this.isValidRule;
  }

  getTooltipStyleTargetField(rule:ColumnCalcRuleViewModel): { [klass: string]: string } {
    if (!rule.tooltipMessageTargetField) return {};

    switch (rule.tooltipTypeTargetField) {
      case 'red':
        return { 'background-color': '#940000' };
      default:
        return {};
    }
  }
  getTooltipStyleExpression(rule:ColumnCalcRuleViewModel): { [klass: string]: string } {
    if (!rule.tooltipMessageExpression) return {};

    switch (rule.tooltipTypeExpression) {
      case 'red':
        return { 'background-color': '#940000' };
      default:
        return {};
    }
  }
  async onRunTransformValidate() {
    if(!await this.validateRules()){
      this.displayError("Validation failed. Please correct the highlighted fields in:\n" + this.invalidRules.join("\n"),"Validation Error");
      return;
    }
    await this.onRunTransform();
  }
  compareDataFarm(o1: DataFarmViewModel, o2: DataFarmViewModel): boolean {
    return o1.name === o2.name && o1.id === o2.id;
  }
}

